export interface IIncidentReportRequest {
    id: number,
    centerId: number,
    incidentDate: string,
    candidateFirstName: string,
    candidateLastName: string,
    centerDisplayUserId: number,
    donorConnectGroup: number,
    incidentCategoryTypeId: number, 
    incidentOriginTypeId: number,
    incidentStatusId: number,
    assignedMentorId: number,
    description: string,
}


